const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

// Find Parts yard-cell colors, location formatting, and complete-powertrain privacy.
(() => {
  const ROOT_ID = 'cap-find-parts-app';
  const ATTACHED_FLAG = 'yardColorsAttached';
  const CELL_TEXT_SELECTOR = [
    '.cap-find-parts__yard',
    '.cap-find-parts__location',
    '.cap-find-parts__stock',
    '.cap-find-parts__stock-label',
    '.cap-find-parts__stock-value',
  ].join(', ');

  // Exact storefront category names currently used for complete engines/motors
  // and complete transmissions. Component part names are intentionally excluded.
  const PRIVATE_POWERTRAIN_TITLES = new Set([
    'engine',
    'engine assembly',
    'complete engine',
    'complete engine assembly',
    'motor',
    'motor assembly',
    'complete motor',
    'complete motor assembly',
    'engine / motor',
    'engine / motor assembly',
    'complete engine / motor',
    'complete engine / motor assembly',
    'transmission',
    'transmission assembly',
    'complete transmission',
    'complete transmission assembly',
  ]);

  // Permit specifications after an unmistakably complete assembly name, such as
  // "Engine Assembly 5.4L" or "Complete Transmission Automatic".
  const PRIVATE_POWERTRAIN_PATTERNS = [
    /^complete engine(?:\s*\/\s*motor)?(?:\s+assembly)?(?:\s+.+)?$/,
    /^complete motor(?:\s+assembly)?(?:\s+.+)?$/,
    /^complete transmission(?:\s+assembly)?(?:\s+.+)?$/,
    /^engine(?:\s*\/\s*motor)?\s+assembly(?:\s+.+)?$/,
    /^motor\s+assembly(?:\s+.+)?$/,
    /^transmission\s+assembly(?:\s+.+)?$/,
  ];

  function normalizeYard(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/\./g, '')
      .replace(/\s+/g, ' ');
  }

  function normalizePartTitle(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/\s*\/\s*/g, ' / ')
      .replace(/\s+/g, ' ');
  }

  function isPrivatePowertrainTitle(value) {
    const title = normalizePartTitle(value);
    if (!title) return false;
    if (PRIVATE_POWERTRAIN_TITLES.has(title)) return true;
    return PRIVATE_POWERTRAIN_PATTERNS.some((pattern) => pattern.test(title));
  }

  function getYardColor(value) {
    const yard = normalizeYard(value);

    if (yard === 'mesquite') return '#ffd400';
    if (yard === 'fort worth' || yard === 'ft worth' || yard === 'fortworth') {
      return '#32d583';
    }

    return '';
  }

  function applyPowertrainPrivacy(root) {
    root.querySelectorAll('.cap-find-parts__results tr').forEach((row) => {
      const titleElement = row.querySelector('.cap-find-parts__part-title');
      const shouldHide =
        root.dataset.mode === 'parts' &&
        isPrivatePowertrainTitle(titleElement ? titleElement.textContent : '');
      const locationElement = row.querySelector('.cap-find-parts__location');
      const stockElement = row.querySelector('.cap-find-parts__stock-value');
      const locationLine = locationElement ? locationElement.closest('.cap-find-parts__stock') : null;
      const stockLine = stockElement ? stockElement.closest('.cap-find-parts__stock') : null;

      [locationLine, stockLine].forEach((line) => {
        if (line) line.style.display = shouldHide ? 'none' : '';
      });

      row.classList.toggle('cap-find-parts__row--private-powertrain', shouldHide);
    });
  }

  function applyYardColors(root) {
    applyPowertrainPrivacy(root);

    root.querySelectorAll('.cap-find-parts__yard').forEach((yardElement) => {
      const cell = yardElement.closest('td');
      const color = getYardColor(yardElement.textContent);

      yardElement.style.color = color;
      if (!cell) return;

      const locationElement = cell.querySelector('.cap-find-parts__location');
      const locationLabel = cell.querySelector('.cap-find-parts__location-label');

      // Keep only the physical location code, without the word "Location".
      if (locationLabel) {
        locationLabel.style.display = 'none';
      }

      // Make the physical location code at least as prominent as the yard name.
      if (locationElement) {
        locationElement.style.fontSize = window.getComputedStyle(yardElement).fontSize;
        locationElement.style.lineHeight = '1.2';
      }

      // Yard, location, stock label, and stock number all inherit the yard color.
      cell.style.color = color;
      cell.querySelectorAll(CELL_TEXT_SELECTOR).forEach((element) => {
        element.style.color = color;
      });
    });
  }

  function attachToFindParts(root) {
    applyYardColors(root);

    if (root.dataset[ATTACHED_FLAG] === 'true') return;
    root.dataset[ATTACHED_FLAG] = 'true';

    new MutationObserver(() => applyYardColors(root)).observe(root, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  function initializeYardColors() {
    const existingRoot = document.getElementById(ROOT_ID);
    if (existingRoot) {
      attachToFindParts(existingRoot);
      return;
    }

    const pageObserver = new MutationObserver(() => {
      const root = document.getElementById(ROOT_ID);
      if (!root) return;

      pageObserver.disconnect();
      attachToFindParts(root);
    });

    pageObserver.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeYardColors, { once: true });
  } else {
    initializeYardColors();
  }
})();
